export const getIndexColumn = (currentPage = 1, pageSize = 10) => ({
  title: "Д/Д",
  name: "Д/Д",
  dataIndex: "key",
  key: "key",
  width: 60,
  align: "center",

  //currentPage bolon pageSize deer undeslen global indeksig tootsooloh
  render: (t, r, i) => (currentPage - 1) * pageSize + i + 1,
  show: true,
});
